module.exports = __webpack_public_path__ + "img/pic3.c8b57dde.png";